const search = new URLSearchParams(window.location.search);

const RemoteServiceURIs = {
  clipart: import.meta.env.NDX_CLIPART_URI,
  upload: import.meta.env.NDX_UPLOADS_URI,
  foundry: import.meta.env.NDX_FOUNDRY_URI,
  manipulate: import.meta.env.NDX_CLIPART_TRANSFORMER_URI,
  fonts: import.meta.env.NDX_FONT_CATEGORIES_URI,
  font_info: import.meta.env.NDX_FONT_INFO_URI,
  designs: import.meta.env.NDX_DESIGNS_URI,
  design_ideas: import.meta.env.NDX_DESIGN_IDEAS_URI,
  pricing: import.meta.env.NDX_PRICING_URI,
  products: import.meta.env.NDX_PRODUCTS_URI,
  productImages: import.meta.env.NDX_PRODUCT_IMAGES_URI,
  productImagesDynamic: import.meta.env.NDX_PRODUCTS_URI_DYNAMIC,
  projectEditor: import.meta.env.NDX_PROJECT_EDITOR_URI,
  projects: import.meta.env.NDX_PROJECTS_URI,
  proofImages: import.meta.env.NDX_PROOF_IMAGES_URI,
  stockPile: import.meta.env.NDX_STOCKPILE_URI,
  accounts: import.meta.env.NDX_ACCOUNTS_URI,
  price_quote: import.meta.env.NDX_PRICE_QUOTE_URI,
  catalog: import.meta.env.NDX_CATALOG_URI,
  recommendations: import.meta.env.NDX_RECOMMENDATIONS_URI,
  assisted_design: import.meta.env.NDX_AD_URI,
  fundraising_goals: import.meta.env.NDX_FUNDRAISING_GOALS_URI,
  fundraising: import.meta.env.NDX_FUNDRAISING_URI,
  fundraising_quote: import.meta.env.NDX_FUNDRAISING_QUOTE_URI,
  fundraising_origin: import.meta.env.NDX_FUNDRAISING_ORIGIN_URI,
  fundraising_print_minimum: import.meta.env.NDX_FUNDRAISING_PRINT_MINIMUM_URI,
  profileInfo: import.meta.env.NDX_PROFILE_INFO_URI,
  profiles: import.meta.env.NDX_PROFILE_URI,
  checkout: import.meta.env.NDX_CHECKOUT_URI,
  international_checkout: import.meta.env.NDX_INTERNATIONAL_CHECKOUT_URI,
  internal_checkout: import.meta.env.NDX_INTERNAL_CHECKOUT_URI,
  stores: import.meta.env.NDX_STORES_URI,
  location: import.meta.env.NDX_LOCATIONS_URI,
  geolocation: import.meta.env.NDX_GEOLOCATION_URI,
  auth0ClientId: import.meta.env.NDX_AUTH0_CLIENT_ID,
  auth0Domain: import.meta.env.NDX_AUTH0_DOMAIN,
  auth0Audience: import.meta.env.NDX_AUTH0_AUDIENCE,
  profilesUrl: import.meta.env.NDX_PROFILES_URL,
  profilesRedirectUri: import.meta.env.NDX_PROFILES_REDIRECT_URI,
  profilesClientId: import.meta.env.NDX_PROFILES_CLIENT_ID,
  profilesLogoutUri: import.meta.env.NDX_PROFILE_LOGOUT_URL,
  siteContent: import.meta.env.NDX_SITE_CONTENT,
  signalmizely: import.meta.env.NDX_SIGNALMIZELY_URL,
  groups: import.meta.env.NDX_GROUPS_URL
};

// Allow overriding of RemoteServiceURIs via query params
// e.g. ?catalog_uri=https://staging.my.catalog.uri
Object.keys(RemoteServiceURIs).forEach(key => {
  const override = search.get(`${key}_uri`);
  if (override) {
    RemoteServiceURIs[key] = override;
  }
});

export default RemoteServiceURIs;
